let env, apiLink, stripePk, returnUrl

// for local development and testing
if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') 
{

    env = 'local'
    stripePk = 'pk_test_51JiIZtFmBSOHOQyYQtPx5biEobGQOkWAzqpyZO23hk9lAhbbqhix86ie5u9wFKP0JIPcQOdcrOeE0Fjq34JoZ7Fv00jKymNjD4'
    // if you want to switch between local api instance and staging api,
    // replace apiLink with 'https://zsapi01staging.zmapi.net' or 'http://localhost:4000'
    apiLink = 'https://zsapi01staging.zmapi.net'
    returnUrl = 'http://localhost:3000'

}

// ! build injected env vars
// ! comment these out for this app to work locally - UNCOMMENT FOR DEPLOY
stripePk = 'pk_live_51JiIZtFmBSOHOQyY12J5u3YozK6UZdNG09raMgc81vQY3zFHKTh6Fe8PSWAeoZk8nQMwuxGq5H09dbuApcAjfAjz008AUKCuX6'
apiLink = 'https://zsapi01.zmapi.net'
returnUrl = 'https://checkout.zealinnovations.com'
// possible values of env when injected during build are 'production' 'beta' or 'staging'
env = 'production'
// ! end of build injected env vars - UNCOMMENT FOR DEPLOY

export {
    apiLink,
    env,
    stripePk,
    returnUrl
}